import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-field-checkbox',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyModule
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    template: `
            <div [class]="'form-group has-feedback ' + props['htmlClass']"
                [class.has-success]="(formControl.dirty || formControl.touched) && formControl.status === 'VALID'"
                [class.has-error]="(formControl.dirty || formControl.touched) && formControl.status === 'INVALID'"
                >
                <div class="square_checkbox">
                    <input
                        [attr.required]="props['required']"
                        [formControl]="formControl"
                        [formlyAttributes]="field"
                        type="checkbox"
                        [attr.disabled]="props['readonly']"
                        [class]="props['fieldHtmlClass'] + 'sr-only'"
                        [id]="field.key!.toString()"
                        [name]="field.key!.toString()"
                        hidden
                    >
                    <label [for]="field.key" [class]="props['labelHtmlClass']">{{props['title']}}</label>
                    <!-- <a ng-click="buttonClick($event,form)">{{form.linkTitle}}</a> -->
                    <div *ngIf="(formControl.dirty || formControl.touched) && formControl.status === 'INVALID'" class="help-block">
                        {{props['description']}}
                        <formly-validation-message [field]="field"></formly-validation-message>
                    </div>
                </div>
            </div>
  `
})
export class CheckboxFieldTypeComponent extends FieldType<FieldTypeConfig> { }
